export const categories = {
  ALL: "Alla",
  PRACTICAL: "Praktisk",
  THEORETICAL: "Teoretisk",
  APP: "App",
  LAB_KIT: "Labbkit",
};
